import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  height: "45",
  class: /*#__PURE__*/_normalizeClass(`dataEmail selected`),
  style: {"border-bottom":"1px solid #efefef","line-height":"45px"}
}
const _hoisted_2 = { style: {} }
const _hoisted_3 = {
  key: 0,
  class: "fl"
}
const _hoisted_4 = {
  key: 1,
  class: "fl mt2"
}
const _hoisted_5 = {
  key: 2,
  class: "fr grey",
  style: {"margin-right":"20px"}
}
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WeekdayButtons = _resolveComponent("WeekdayButtons")!

  return (_ctx.adow || (_ctx.dayOfTheWeek && _ctx.startHour))
    ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
        _createElementVNode("td", _hoisted_2, [
          _createVNode(_component_WeekdayButtons, {
            classes: `small mr4`,
            dayOfTheWeek: _ctx.adow ? _ctx.adow.days_of_the_week : _ctx.dayOfTheWeek,
            canEditWeek: false,
            style: {"padding":"0 15px"},
            onUpdateHoliday: _ctx.updateHoliday,
            showHoliday: true,
            useHoliday: _ctx.adow?.use_holiday
          }, null, 8, ["dayOfTheWeek", "onUpdateHoliday", "useHoliday"]),
          (_ctx.adow)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.zeroPadding(_ctx.adow.start_hour)) + ":" + _toDisplayString(_ctx.zeroPadding(_ctx.adow.start_min)) + " ~ " + _toDisplayString(_ctx.zeroPadding(_ctx.adow.end_hour)) + ":" + _toDisplayString(_ctx.zeroPadding(_ctx.adow.end_min)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(`${_ctx.startHour.padStart(2, "0")}:${_ctx.startMin.padStart(2, "0")}`) + _toDisplayString(_ctx.endHour ? `~${_ctx.endHour.padStart(2, "0")}:${_ctx.endMin.padStart(2, "0")}` : ``), 1)),
          (_ctx.showDeleteButton)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
                  width: "20",
                  height: "20",
                  class: "fr pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteAdow(_ctx.adow)))
                }, null, 8, _hoisted_6)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}